import type { AdicionarMembro, AtualizarCliente, PapelNoCliente } from "@base/contracts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { chavesDeClientes, useClientesGateway } from "./clientes.contexto";

function useInvalidarClientes() {
  const cliente = useQueryClient();
  return () => cliente.invalidateQueries({ queryKey: chavesDeClientes.todos });
}

export function useCriarCliente() {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({ mutationFn: (nome: string) => gateway.criar(nome), onSuccess: () => invalidar() });
}

export function useAtualizarCliente() {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({
    mutationFn: ({ id, dados }: { id: string; dados: AtualizarCliente }) => gateway.atualizar(id, dados),
    onSuccess: () => invalidar(),
  });
}

export function useExcluirCliente() {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({
    mutationFn: (id: string) => gateway.excluir(id),
    onSuccess: () => invalidar(),
  });
}

export function useMembros(clienteId: string | null) {
  const gateway = useClientesGateway();
  return useQuery({
    queryKey: chavesDeClientes.membros(clienteId ?? ""),
    queryFn: () => gateway.membros(clienteId as string),
    enabled: clienteId !== null,
  });
}

export function useAdicionarMembro(clienteId: string) {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({
    mutationFn: (dados: AdicionarMembro) => gateway.adicionarMembro(clienteId, dados),
    onSuccess: () => invalidar(),
  });
}

export function useAlterarPapelDoMembro(clienteId: string) {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({
    mutationFn: ({ usuarioId, papel }: { usuarioId: string; papel: PapelNoCliente }) =>
      gateway.alterarPapel(clienteId, usuarioId, papel),
    onSuccess: () => invalidar(),
  });
}

export function useEnviarLinkDeSenhaDoMembro(clienteId: string) {
  const gateway = useClientesGateway();
  return useMutation({
    mutationFn: (usuarioId: string) => gateway.enviarLinkDeSenha(clienteId, usuarioId),
  });
}

export function useRemoverMembro(clienteId: string) {
  const gateway = useClientesGateway();
  const invalidar = useInvalidarClientes();
  return useMutation({
    mutationFn: (usuarioId: string) => gateway.removerMembro(clienteId, usuarioId),
    onSuccess: () => invalidar(),
  });
}
